'use client';

import { createContext, useContext } from 'react';
import {
  type NavData,
  fallbackHeaderItems,
  fallbackCtaButtons,
  fallbackFooterColumns,
} from '@/lib/nav';

const NavContext = createContext<NavData>({
  headerItems: fallbackHeaderItems,
  ctaButtons: fallbackCtaButtons,
  footerColumns: fallbackFooterColumns,
});

export function useNav(): NavData {
  return useContext(NavContext);
}

export default function NavProvider({
  value,
  children,
}: {
  value: NavData;
  children: React.ReactNode;
}) {
  return <NavContext.Provider value={value}>{children}</NavContext.Provider>;
}
